import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { DropDown } from 'src/app/interfaces/drop-down.interface';
import { LocationService } from 'src/app/services/location.service';
import { LogService } from 'src/app/services/log.service';

export const LOCATION_FORM_CONTROL_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LocationFormFieldComponent),
  multi: true,
};

@Component({
  selector: 'app-location-form-field',
  providers: [LOCATION_FORM_CONTROL_ACCESSOR],
  templateUrl: './location-form-field.component.html',
  styleUrls: ['./location-form-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationFormFieldComponent
  implements ControlValueAccessor, OnChanges, AfterViewInit
{
  @ViewChild('locationField') locationField: DropDownList;
  @Input() orgId: number = null;
  @Input() includeChildOrgs: boolean = false;
  @Input() placeholder: string = 'General.SelectLocation';

  options: DropDown<number>[] = null;
  fields: Object = { value: 'value', text: 'text' };
  private _value: DropDown<number> | null = null;

  private _disabled: boolean = false;
  public get disabled(): boolean {
    return this._disabled;
  }
  @Input() public set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(
    private _ls: LocationService,
    private _lgr: LogService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.updateLocationFieldValue();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(!this.orgId || this.orgId === 0)
    {
      this.writeValue(null); //reset the value
      this.options = null;
      return;
    }
    this.loadOptions();
  }

  onLocationChanged($event) {
    this._value = $event.itemData;
    this.onTouched();
    this.onChange(this._value);
  }

  // Function to call when the input changes.
  onChange = (value: DropDown<number>) => {};

  // Function to call when the input is touched.
  onTouched = () => {};

  private loadOptions() {
    this.locationField?.showSpinner();
    this._cdr.markForCheck();
    this.options = null;
    this._ls.getLocationDropDownListByOrgId(this.orgId, this.includeChildOrgs)
    .subscribe((locs) => {
      this.locationField?.hideSpinner();
      this.options = locs?.sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
      this.writeValue(null); //reset the value
      setTimeout(() => {
          this._cdr.detectChanges();
      } , 0);
    });
  }

  // Allows Angular to update the model (organizationControl).
  // Update the model and changes needed for the view here.
  writeValue(value: DropDown<number>): void {
    this._value = value;
    //set the value of the dropdown
    this.updateLocationFieldValue();
    this.onChange(value);
  }

  private updateLocationFieldValue() {
    if (this.locationField) {
      if (this._value?.value) {
        this.locationField.value = this._value?.value ?? {};
      } else {
        this.locationField.index = null;
      }
    }
  }
  // Allows Angular to register a function to call when the model (organizationControl) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._cdr.markForCheck();
  }
}
